export default {
  Loading: 'Chargement en cours...',
  search: 'Recherche...',
  noMessages: 'Aucun message',
  noSearchResults: 'Aucune correspondance de registre trouvée',
};
